import React from 'react';
import { Star } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function SocialProofBar() {
  return <FadeIn data-id="element-392">
      <div className="w-full bg-[#faf7f2] border-y border-[#e7dfce] py-6 shadow-sm" data-id="element-393">
        <div className="max-w-5xl mx-auto px-4 flex flex-wrap justify-center items-center gap-x-8 gap-y-4 text-center font-bold" data-id="element-394">
          <div className="text-lg text-[#1f1b16]" data-id="element-395">+500 personas</div>
          <div className="hidden sm:block text-[#e7dfce]" data-id="element-396">•</div>
          <div className="text-lg text-[#1f1b16]" data-id="element-397">6 Tomos</div>
          <div className="hidden sm:block text-[#e7dfce]" data-id="element-398">•</div>
          <div className="text-lg text-[#1f1b16]" data-id="element-399">6 Bonos</div>
          <div className="hidden sm:block text-[#e7dfce]" data-id="element-400">•</div>
          <div className="flex items-center gap-1 text-lg text-[#1f1b16]" data-id="element-401">
            4,9/5
            <div className="flex text-[#7c3aed] ml-1" data-id="element-402">
              <Star size={18} fill="currentColor" data-id="element-403" />
            </div>
          </div>
        </div>
      </div>
    </FadeIn>;
}